import SpriteSymbol from "../../.yarn/cache/svg-baker-runtime-npm-1.4.7-fbb2e3215b-925379c771.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../.yarn/cache/svg-sprite-loader-npm-6.0.11-0d03c2400c-ddbd5ea43d.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 192 192",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 192\" id=\"close\"><path d=\"M101.657 96l57.172 57.171-5.658 5.658L96 101.657 38.829 158.83l-5.658-5.658L90.343 96 33.17 38.829l5.658-5.658L96 90.343l57.171-57.172 5.658 5.658L101.657 96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol